import { SET_SENSORS } from '../constants/actionTypes';

const sensors = (state = null, action) => {
  switch (action.type) {
    case SET_SENSORS:
      return { ...action.payload };
    default:
      return state;
  }
};

export default sensors;



// WEBPACK FOOTER //
// ./src/redux/sensors.js